import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { isKnownExternalBrowserNoise, scrubSensitivePasswordResetData } from './sentryEventFilters'

Sentry.init({
  Vue,
  dsn: process.env.SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing(), new Sentry.Replay()],
  environment: process.env.NODE_ENV || 'dev',
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend (event, hint) {
    if (isKnownExternalBrowserNoise(event, hint)) return null
    return scrubSensitivePasswordResetData(event)
  },
  logErrors: true
})
